<template>
  <div class="flex">
    <input
      class="mr-2"
      :id="id"
      :value="modelValue"
      type="checkbox"
      @input="onChange"
      :required="required"
      :checked="modelValue"
    />
    <label :for="id">
      <slot></slot>
    </label>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  id: string;
  modelValue: boolean;
  required?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.checked);
};
</script>
